var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStereotypes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 108,
    viewBox: "0 0 276 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5302 26.398C35.7708 22.9581 37.3474 16.8768 34.8021 13.9487C32.705 11.5362 27.5211 10.0234 24.4359 11.3055C15.2612 15.1179 13.3724 32.6879 14.8324 40.9372C15.4265 44.2939 16.5635 46.8134 20.3358 47.0772C24.0262 47.3352 27.4593 42.6981 30.9624 41.4257C33.1096 40.6457 34.8525 37.2215 31.592 36.9935C29.279 36.8317 19.8928 34.9243 18.8206 36.7399",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.559 16.1582C43.9446 24.9449 44.6198 33.5781 44.0073 42.3375C43.9072 43.7695 43.285 46.0404 43.7927 47.4382C44.424 49.176 45.2473 47.0024 46.1542 46.1823C48.4205 44.1329 50.9207 41.542 54.2779 41.7767",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1717 30.8389L52.4442 31.4173",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5605 17.2975C45.5685 17.5078 50.7583 18.9369 53.4229 17.4176",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3747 16.2646L61.9274 51.2638",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0632 20.7193C67.9904 25.6966 69.973 32.4722 73.3403 37.9229C74.342 39.5444 75.6785 41.5673 76.4086 43.3242C76.4418 43.404 76.7092 46.1344 77.0002 45.5326C77.6559 44.1762 77.314 41.5526 77.4138 40.1261C77.7895 34.7525 78.1653 29.3789 78.541 24.0053C78.714 21.5321 81.3749 7.08846 79.1754 5.78949",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6042 20.0874C91.0702 27.7236 90.5363 35.3598 90.0023 42.996C89.9161 44.2282 89.4954 45.8918 89.7509 47.0994C90.015 48.3478 94.2445 48.4173 94.8846 48.4374C100.271 48.6064 106.878 50.2482 110.915 43.6768C115.688 33.6243 113.7 25.9023 108.006 23.2948C103.565 20.7978 95.3509 17.2948 90.376 19.3621",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M121.233 17.0439C120.588 26.2642 123.141 35.4751 122.501 44.6294C122.242 48.3346 128.848 46.9766 132.533 46.6791",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M122.073 32.4492L131.618 33.1167",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M120.373 20.1809C123.349 20.389 126.137 20.6108 129.006 20.1806C130.388 19.9733 132.479 19.7485 133.825 19.8427",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M139.82 16.4248C139.2 25.2923 140.52 33.8501 139.904 42.6486C139.779 44.4454 138.422 51.3813 139.873 52.2383",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M139.642 18.9707C144.451 19.307 151.067 20.1886 150.631 26.418C150.343 30.5351 145.758 34.7454 141.437 34.4433C139.044 34.2759 143.414 35.221 144.256 35.2799C147.559 35.5108 149.134 38.1411 151.076 40.3751C152.974 42.5584 153.391 44.198 154.691 46.5962C155.226 47.5818 155.954 50.8899 155.96 50.8059",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M54.127 62.2295C52.5229 60.5895 48.3196 57.8292 45.988 59.742C43.8034 61.5341 43.144 63.8332 42.9531 66.5638C42.8041 68.6948 46.4592 68.0879 48.0963 68.2024C51.5094 68.4411 51.6675 69.9682 51.4615 72.9139C51.2417 76.0564 48.7132 78.2253 45.8812 79.5578C42.213 81.2837 39.6176 81.0382 35.5662 80.7549C34.6143 80.6883 28.2567 79.7762 29.928 79.0817",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4862 60.3955C63.9606 67.9122 64.7247 75.2739 64.2015 82.7567",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9853 59.0918L76.6212 60.6047",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8007 59.6882C81.2667 67.3244 80.7327 74.9606 80.1988 82.5967C80.0586 84.601 79.627 83.947 80.53 82.9396C84.9612 83.2495 91.214 83.367 94.9134 83.6257",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2287 71.8672C86.0654 72.1355 89.9917 73.0495 93.6385 73.3045",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M80.395 61.5078C84.6771 61.8072 89.1192 62.7573 93.0775 63.0341",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M102.209 60.4756C101.582 69.4492 102.243 78.2886 101.613 87.2912",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M101.987 63.6576C104.317 63.5623 113.067 60.6572 112.75 65.1918C112.428 69.7973 111.06 73.884 105.774 73.5143C98.8693 73.0315 109.341 73.1606 110.855 74.0117C114.643 76.1416 116.112 81.1241 115.835 85.0887",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M125.709 62.7588C125.25 69.3344 124.79 75.91 124.33 82.4856C124.284 83.1415 124.128 85.2032 125.187 84.3382C129.612 83.555 135.932 84.5334 137.571 84.1116",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M125.042 72.3037L133.314 72.8822",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M124.393 63.3057L139.665 64.3736",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M153.798 63.4434C150.495 63.2125 147.294 70.1218 146.111 72.782C145.336 74.5225 144.207 78.4414 145.596 80.1354C148.29 83.4186 154.779 89.4021 159.357 86.5685C163.446 84.0379 166.101 75.6223 164.268 71.2096C162.18 66.1848 156.569 64.9162 151.8 64.5826",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M176.796 63.7725C176.261 71.4116 175.296 94.3646 175.83 86.7255",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M164.616 64.2002L187.524 65.8021",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M191.978 66.1139C191.752 69.3465 191.942 73.7539 193.963 76.3419C194.687 77.2695 196.723 82.7874 197.204 82.8211C198.348 82.9011 202.716 75.8614 203.393 74.5856C204.658 72.2034 205.196 69.1259 205.386 66.412",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M203.537 74.4023C203.014 81.8816 203.804 94.9883 201.298 98.4155C198.807 102.689 189.174 100.981 186.722 99.1393",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M212.431 66.2646L209.85 103.173",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M212.342 67.5374C214.847 67.7126 217.509 67.2938 219.253 69.2996C221.434 71.8087 220.862 73.7289 220.638 76.9278C220.47 79.3313 218.289 81.9168 216.497 83.317C215.354 84.2095 211.152 85.2169 211.324 82.7567",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M227.57 69.2416C227.187 74.7095 226.805 80.1774 226.423 85.6453C226.249 88.1219 225.94 89.0897 225.384 93.3883C224.991 99.0019 230.011 96.4681 235.423 96.8466",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M226.501 84.5137L234.137 85.0476",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M226.844 70.4693C228.265 70.5686 235.206 70.6785 237.808 70.8605",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M259.164 74.6479C256.374 71.438 249.261 69.7836 246.093 73.5918C244.419 75.605 243.627 78.9441 244.012 81.5106C244.294 83.3933 251.148 81.3025 251.955 81.2134C256.927 80.664 254.543 89.307 251.942 91.0531C250.295 92.1585 242.335 95.8408 242.646 91.3977",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M4.47899 28.1562C16.5582 29.0008 28.6373 29.9972 40.7259 30.6908C50.6222 31.2586 60.8038 29.9009 70.7062 29.486C82.5836 28.9884 94.7403 28.926 106.625 29.29C115.266 29.5546 123.92 29.6053 132.566 29.6203C139.317 29.632 146.116 30.4955 152.853 30.1857C155.07 30.0838 166.087 32.1499 167.244 30.1906",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8392 71.2541C57.8525 73.2829 86.872 75.7691 115.916 77.306C145.326 78.8622 174.911 78.2446 204.356 78.7054C220.072 78.9514 235.523 80.2646 251.238 79.7953C257.46 79.6095 276.121 80.5338 269.911 80.0996",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStereotypes);
export default __webpack_public_path__ + "static/media/stereotypes.dcf756ba72ae04be09bf31034f249c21.svg";
export { ForwardRef as ReactComponent };